import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Params, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ENVIRONMENT } from 'projects/shared/lib/environment/environment';
import { INavigationEnvironment } from './interfaces/environment/navigation/navigation-environment.interface';
import { IAuthService, IAuthServiceToken } from './services/infrastructure/authentication/auth-service.interface';
import { ServiceLocator } from './services/infrastructure/service-locator.service';
import { IConfigurationServiceToken } from './services/infrastructure/configuration/configuration-service.interface';

@Injectable({
  providedIn: 'root'
})
export class RedirectGuard  {
  private authorizedLandingPage: INavigationEnvironment;
  private anonymousLandingPage: INavigationEnvironment;
  private readonly authService: IAuthService;

  constructor(
    private router: Router
  ) {
    this.authService = inject(IAuthServiceToken);
    this.authorizedLandingPage = ENVIRONMENT.authorizedLandingPage;
    ServiceLocator.injector.get(IConfigurationServiceToken).authorizedLandingPageGet().subscribe((targetPage) => {
      this.authorizedLandingPage.routerlink = targetPage.routerlink as string;
      let queryParams = new URLSearchParams(targetPage.queryParams);
      let queryParamsObject: Params = {};
      queryParams.forEach((value, key) => {
        queryParamsObject[key] = value;
      });
      this.authorizedLandingPage.queryParams = queryParamsObject;
    });

    this.anonymousLandingPage = ENVIRONMENT.anonymousLandingPage;
    ServiceLocator.injector.get(IConfigurationServiceToken).anonymousLandingPageGet().subscribe((anonymousLandingPage) => {
      this.anonymousLandingPage.routerlink = anonymousLandingPage.routerlink as string;
      let queryParams = new URLSearchParams(anonymousLandingPage.queryParams);
      let queryParamsObject: Params = {};
      queryParams.forEach((value, key) => {
        queryParamsObject[key] = value;
      });
      this.anonymousLandingPage.queryParams = queryParamsObject;
    });
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.redirectTargetUrlTreeGet();
  }

  private redirectTargetUrlTreeGet() {
    let isAuthenticated = this.authService.isAuthenticated();
    let redirectTarget: INavigationEnvironment;

    if (isAuthenticated) {
      redirectTarget = this.authorizedLandingPage;
    } else {
      redirectTarget = this.anonymousLandingPage;
    }

    let urlTree = this.router.createUrlTree([redirectTarget.routerlink], { queryParams: redirectTarget.queryParams });
    return urlTree;
  }

}
